var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-awards" }, [
      _c("div", { staticClass: "footer-awards__item" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://www.goodfirms.co/company/bliss-applications"
            }
          },
          [
            _c("img", {
              staticClass: "footer-awards__image",
              attrs: {
                src:
                  "https://assets.goodfirms.co/badges/normal-badge/app-development.svg",
                alt: "GoodFirms Badge"
              }
            })
          ]
        )
      ]),
      _c("div", { staticClass: "footer-awards__item" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://www.topdevelopers.co/directory/mobile-app-development-companies"
            }
          },
          [
            _c("img", {
              staticClass: "footer-awards__image",
              attrs: {
                src:
                  "https://www.topdevelopers.co/assets/badges/app-2021/Mobile-App/Global/Badge-Top-Mobile-App-Development-Companies-2021.png",
                alt: "Mobile App Development Companies",
                title: "Mobile App Development Companies"
              }
            })
          ]
        )
      ]),
      _c("div", { staticClass: "footer-awards__item" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://techreviewer.co/top-software-development-companies/"
            }
          },
          [
            _c("img", {
              staticClass: "footer-awards__image",
              attrs: {
                src:
                  "https://uploads-ssl.webflow.com/5e455d4bcdc92acda84070ff/5f0de38b60be1d8daadcd848_badge_techreviewer-software_developers-2020.svg",
                alt: "Techreviewer badge"
              }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f187584", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f187584","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-awards-view.vue
// module id = 416
// module chunks = 58